import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { getTypeformEmbedUrl } from '../lib/typeform';
interface WaitlistDialogProps {
  open: boolean;
  onClose: () => void;
}
/**
 * Popup (modal) que muestra el Typeform en un iframe, sin sacar al usuario
 * de la landing. Sin librerías externas: overlay + iframe propios.
 */
export function WaitlistDialog({
  open,
  onClose
}: WaitlistDialogProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  // Cerrar con ESC y bloquear el scroll del fondo mientras está abierto
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-149">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} role="dialog" aria-modal="true" aria-label="Sumarte a la lista de espera" data-id="element-150">
          {/* Fondo */}
          <button type="button" aria-label="Cerrar" onClick={onClose} className="absolute inset-0 h-full w-full cursor-default bg-espresso-2/80 backdrop-blur-sm" data-id="element-151" />

          {/* Contenedor */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.97,
        y: 12
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.97,
        y: 12
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative flex h-[80vh] max-h-[680px] w-full max-w-[640px] flex-col overflow-hidden rounded-lg border border-white/[0.16] border-t-[3px] border-t-camel bg-espresso shadow-2xl" data-id="element-152">
            <div className="flex items-center justify-between border-b border-white/[0.12] px-4 py-3" data-id="element-153">
              <span className="font-mono text-[11px] uppercase tracking-[1.5px] text-white/55" data-id="element-154">
                Lista de espera · Cofit
              </span>
              <button ref={closeRef} type="button" onClick={onClose} aria-label="Cerrar" className="flex h-8 w-8 items-center justify-center rounded text-white/70 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-camel-light" data-id="element-155">
                <XIcon className="h-5 w-5" data-id="element-156" />
              </button>
            </div>

            <iframe title="Formulario de lista de espera de Cofit" src={getTypeformEmbedUrl()} className="h-full w-full flex-1 border-0 bg-espresso" allow="camera; microphone; autoplay; encrypted-media;" data-id="element-157" />
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}